const Skeleton = ({ className = '', ...props }) => (
  <div className={`skeleton rounded-lg ${className}`} {...props} />
);

export default Skeleton;
